// ** Types
import type { StrapiMedia } from '@/features/ap03/types/ap03-strapi';
import type { ComponentSharedTextEditor } from '@/types/graphql';

/**
 * Expected shape of a single competition card item
 */
export type StrapiCompetitionCardItem = {
	id?: number | string;
	name?: string | null;
	description?: string | null;
	ctaLabel?: string | null;
	ctaHref?: string | null;
	ranking?: number | null;
	image?: { data?: StrapiMedia | null } | null;
	fullDescription?: ComponentSharedTextEditor;
	trainingCompany?: string | null;
	guild?: string | null;
	material?: string | null;
	extraImages?: { data?: StrapiMedia[] | null } | null;
};
